export default [
    {
        "id": "filterPanel-1",
        "plugin": null,
        "pluginId": null,
        "name": "filters",
        "html": require('./filterPanels/filterPanel-1/html').default,
        "js": require('./filterPanels/filterPanel-1/js').default,
        "minJs": require('./filterPanels/filterPanel-1/minJs').default,
        "config": `{}`,
        "showOptions": true,
        "settings": `{"filterPanelView":"left"}`,
        "order": 1,
        "allowToMove": false,
        "column": {
            "id": "columnFilter-1",
            "plugin": null,
            "pluginId": null,
            "name": null,
            "isNoneDrag": true,
            "isNoneDelete": true,
            "hideOnmainBody": true,
            "svgContent": require('./filterPanels/filterPanel-1/columnSvgContent').default,
            "svgViewBox": "7 0 323 591"
        },
        "svgContent": require('./filterPanels/filterPanel-1/svgContent').default,
        "svgViewBox": "0 0 1440 125",
        "svgContentMobile": require('./filterPanels/filterPanel-1/svgContentMobile').default,
        "svgViewBoxMobile": " 0 0 360 100",
        "pages": 'ProductList',
    }
]
